/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementListItemIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementListItemIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g opacity="0.4">
            <path
              d="M4 10.5C4.27614 10.5 4.5 10.7239 4.5 11V12C4.5 12.2761 4.27614 12.5 4 12.5H3C2.72386 12.5 2.5 12.2761 2.5 12V11C2.5 10.7239 2.72386 10.5 3 10.5H4Z"
              fill="currentColor"
            />
            <path d="M14 12H6V11H14V12Z" fill="currentColor" />
          </g>
          <g>
            <path
              d="M4 6.5C4.27614 6.5 4.5 6.72386 4.5 7V8C4.5 8.27614 4.27614 8.5 4 8.5H3C2.72386 8.5 2.5 8.27614 2.5 8V7C2.5 6.72386 2.72386 6.5 3 6.5H4Z"
              fill="currentColor"
            />
            <path d="M14 8H6V7H14V8Z" fill="currentColor" />
          </g>
          <g opacity="0.4">
            <path
              d="M4 2.5C4.27614 2.5 4.5 2.72386 4.5 3V4C4.5 4.27614 4.27614 4.5 4 4.5H3C2.72386 4.5 2.5 4.27614 2.5 4V3C2.5 2.72386 2.72386 2.5 3 2.5H4Z"
              fill="currentColor"
            />
            <path d="M14 4H6V3H14V4Z" fill="currentColor" />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementListItemIcon.tags = [
  'list',
  'list item',
  'bullet',
  'options',
  'menu',
  'tasks',
  'checklist',
];

ElementListItemIcon.category = 'Navigator';

ElementListItemIcon.iconSize = 16;
